import { Button } from '@mui/material';
import { styled } from '@mui/system';

const CtaButton = styled(Button)`
	padding: 12px 24px;
	font-size: 16px;
	line-height: 150%;
	border-radius: 10px;
	background-color: #7227d0;
    '&:hover': {
       background-color: #571ca1;
    },
`;

export default CtaButton;
